import { Duration, Timestamp } from '@bufbuild/protobuf';
import { generateTypes } from '@evmos/eip712';
import { TxContext, TxPayload, createTransactionPayload } from '@evmos/transactions';
import { EIP712TypedData } from '@evmos/transactions/dist/messages/base';
import { MsgVote } from '../ts-client/tx';
import { MsgVote as MsgVoteProto } from '../proto/tx_pb';

const MSG_VOTE_TYPES = {
  MsgValue: [
    { name: 'voter', type: 'string' },
    { name: 'weights', type: 'TypeWeights[]' },
  ],
  TypeWeights: [
    { name: 'gauge_id', type: 'uint64' },
    { name: 'weight', type: 'string' },
  ],
};

export const createTxMsgSponsorshipVote = (context: TxContext, params: MsgVote): TxPayload => {
  const typedData = createEIP712MsgVote(context, params);
  const cosmosMsg = createCosmosMsgVote(context, params);
  return createTransactionPayload(context, typedData, cosmosMsg);
};

const createEIP712MsgVote = (context: TxContext, params: MsgVote): EIP712TypedData => {
  const types = generateTypes(MSG_VOTE_TYPES);
  const message = createMsgVote(params);
  return { types, message };
};

const createCosmosMsgVote = (context: TxContext, params: MsgVote): any => {
  const message = new MsgVoteProto({
    voter: params.voter,
    weights: params.weights.map((weight) => ({
      weight: weight.weight,
      gaugeId: BigInt(weight.gaugeId),
    })),
  });
  return { message, path: MsgVoteProto.typeName };
};

function createMsgVote(params: MsgVote): object | object[] {
  return {
    type: 'sponsorship/Vote',
    value: {
      voter: params.voter,
      weights: params.weights.map((weight) => ({
        gauge_id: weight.gaugeId.toString(),
        weight: weight.weight,
      })),
    },
  };
}

